import { render, staticRenderFns } from "./personal-settings.vue?vue&type=template&id=163d3148"
import script from "./personal-settings.vue?vue&type=script&lang=js"
export * from "./personal-settings.vue?vue&type=script&lang=js"
import style0 from "./personal-settings.vue?vue&type=style&index=0&id=163d3148&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports